import { Patient } from '@dataTypes/PatientInfo.types'
import moment from 'moment'

export interface FamilyMemberInfo {
  patient_member_id: string
  relation_to_patient: string
  status?: 'Active' | 'Inactive'
  patient_member_info: Patient
}

export const mockFamilyMembers: Record<string, FamilyMemberInfo[]> = {
  'mock-patient-1': [
    {
      patient_member_id: 'mock-fam-1-1',
      relation_to_patient: 'Spouse',
      status: 'Active',
      patient_member_info: {
        patient_id: 'mock-fam-patient-1-1',
        first_name: 'Cynthia',
        middle_name: 'Elizabeth',
        last_name: 'Doe',
        date_of_birth: '1990-02-12',
        address: '123 Main Street',
        city: 'New York',
        state: 'NY',
        zip: '10001',
        gender: 'Female',
        marital_status: 'Married',
        profession: 'Teacher',
        company_name: 'City School District',
        cellphone: '555-0102',
        email: 'sarah.doe@example.com',
        allergy_ids: [],
        patient_allergies: [],
        medical_condition_ids: [],
        patient_medical_conditions: [],
        has_insurance: true,
        insurance_provider: 'Blue Cross',
        policy_number: 'BC123456',
        join_referral_program: false,
        preferred_appointment_time: 'Morning',
        contact_via_phone: true,
        contact_via_sms: true,
        contact_via_email: true,
        contact_via_app: false,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone', 'sms', 'email'],
      },
    },
    {
      patient_member_id: 'mock-fam-1-2',
      relation_to_patient: 'Child',
      status: 'Inactive',
      patient_member_info: {
        patient_id: 'mock-fam-patient-1-2',
        first_name: 'Kyle',
        middle_name: 'James',
        last_name: 'Doe',
        date_of_birth: '2008-05-16',
        address: '123 Main Street',
        city: 'New York',
        state: 'NY',
        zip: '10001',
        gender: 'Male',
        marital_status: 'Single',
        profession: 'Student',
        company_name: 'Elementary School',
        cellphone: '555-0103',
        email: 'emma.doe@example.com',
        allergy_ids: ['mock-allergy-0'],
        patient_allergies: [
          {
            allergy_id: 'mock-allergy-0',
            allergy: { allergy_id: 'mock-allergy-0', title: 'Peanut' },
          },
        ],
        medical_condition_ids: [],
        patient_medical_conditions: [],
        has_insurance: true,
        insurance_provider: 'Blue Cross',
        policy_number: 'BC123456',
        join_referral_program: false,
        preferred_appointment_time: 'Afternoon',
        contact_via_phone: true,
        contact_via_sms: false,
        contact_via_email: false,
        contact_via_app: false,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone'],
      },
    },
    {
      patient_member_id: 'mock-fam-1-3',
      relation_to_patient: 'Child',
      status: 'Active',
      patient_member_info: {
        patient_id: 'mock-fam-patient-1-3',
        first_name: 'Jake',
        middle_name: 'Robert',
        last_name: 'Doe',
        date_of_birth: '2008-05-16',
        address: '123 Main Street',
        city: 'New York',
        state: 'NY',
        zip: '10001',
        gender: 'Male',
        marital_status: 'Single',
        profession: 'Student',
        company_name: 'Middle School',
        cellphone: '555-0104',
        email: 'jake.doe@example.com',
        allergy_ids: [],
        patient_allergies: [],
        medical_condition_ids: [],
        patient_medical_conditions: [],
        has_insurance: true,
        insurance_provider: 'Blue Cross',
        policy_number: 'BC123456',
        join_referral_program: false,
        preferred_appointment_time: 'Afternoon',
        contact_via_phone: true,
        contact_via_sms: false,
        contact_via_email: false,
        contact_via_app: false,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone'],
      },
    },
  ],
  'mock-patient-2': [
    {
      patient_member_id: 'mock-fam-2-1',
      relation_to_patient: 'Spouse',
      status: 'Active',
      patient_member_info: {
        patient_id: 'mock-fam-patient-2-1',
        first_name: 'Michael',
        middle_name: 'James',
        last_name: 'Smith',
        date_of_birth: moment().subtract(32, 'years').format('YYYY-MM-DD'),
        address: '456 Oak Avenue',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90001',
        gender: 'Male',
        marital_status: 'Married',
        profession: 'Engineer',
        company_name: 'Tech Solutions Inc',
        cellphone: '555-0203',
        email: 'michael.smith@example.com',
        allergy_ids: [],
        patient_allergies: [],
        medical_condition_ids: [],
        patient_medical_conditions: [],
        has_insurance: true,
        insurance_provider: 'Aetna',
        policy_number: 'AE789012',
        join_referral_program: false,
        preferred_appointment_time: 'Morning',
        contact_via_phone: true,
        contact_via_sms: true,
        contact_via_email: true,
        contact_via_app: true,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone', 'sms', 'email', 'app'],
      },
    },
    {
      patient_member_id: 'mock-fam-2-2',
      relation_to_patient: 'Child',
      status: 'Active',
      patient_member_info: {
        patient_id: 'mock-fam-patient-2-2',
        first_name: 'Lucas',
        middle_name: 'Alexander',
        last_name: 'Smith',
        date_of_birth: moment().subtract(5, 'years').format('YYYY-MM-DD'),
        address: '456 Oak Avenue',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90001',
        gender: 'Male',
        marital_status: 'Single',
        profession: 'Student',
        company_name: 'Preschool',
        cellphone: '555-0204',
        email: 'lucas.smith@example.com',
        allergy_ids: [],
        patient_allergies: [],
        medical_condition_ids: [],
        patient_medical_conditions: [],
        has_insurance: true,
        insurance_provider: 'Aetna',
        policy_number: 'AE789012',
        join_referral_program: false,
        preferred_appointment_time: 'Morning',
        contact_via_phone: true,
        contact_via_sms: false,
        contact_via_email: false,
        contact_via_app: false,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone'],
      },
    },
    {
      patient_member_id: 'mock-fam-2-3',
      relation_to_patient: 'Parent',
      status: 'Inactive',
      patient_member_info: {
        patient_id: 'mock-fam-patient-2-3',
        first_name: 'Robert',
        middle_name: 'William',
        last_name: 'Smith',
        date_of_birth: moment().subtract(65, 'years').format('YYYY-MM-DD'),
        address: '789 Pine Street',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90002',
        gender: 'Male',
        marital_status: 'Married',
        profession: 'Retired',
        company_name: 'N/A',
        cellphone: '555-0205',
        email: 'robert.smith@example.com',
        allergy_ids: ['mock-allergy-0'],
        patient_allergies: [
          {
            allergy_id: 'mock-allergy-0',
            allergy: { allergy_id: 'mock-allergy-0', title: 'Penicillin' },
          },
        ],
        medical_condition_ids: ['mock-condition-0', 'mock-condition-1'],
        patient_medical_conditions: [
          {
            medical_condition_id: 'mock-condition-0',
            medical_condition: {
              medical_condition_id: 'mock-condition-0',
              title: 'Hypertension',
            },
          },
          {
            medical_condition_id: 'mock-condition-1',
            medical_condition: {
              medical_condition_id: 'mock-condition-1',
              title: 'Diabetes',
            },
          },
        ],
        has_insurance: true,
        insurance_provider: 'Medicare',
        policy_number: 'MC456789',
        join_referral_program: false,
        preferred_appointment_time: 'Morning',
        contact_via_phone: true,
        contact_via_sms: false,
        contact_via_email: true,
        contact_via_app: false,
        notes: '',
        uploadedFiles: [],
        template: '',
        contact_via: ['phone', 'email'],
      },
    },
  ],
}
